import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { st, classes } from '../FileUpload.st.css';
import FileUploadIndicator from './FileUploadIndicator';
const File = _ref => {
  let {
    file,
    onDeleteClick,
    deleteText,
    dataHook,
    focusFile = false,
    ...rest
  } = _ref;
  const a11yProps = focusFile ? {
    tabIndex: 0
  } : [];
  return /*#__PURE__*/React.createElement("div", _extends({
    className: st(classes.fileContainer, {
      error: file.state === 'error'
    })
  }, a11yProps, {
    "aria-describedby": rest['aria-describedby']
  }), /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    className: classes.file,
    title: file.file.name
  }, file.file.name), /*#__PURE__*/React.createElement("div", {
    className: classes.fileUploadIndicator
  }, /*#__PURE__*/React.createElement(FileUploadIndicator, {
    state: file.state,
    onDeleteClick: onDeleteClick,
    deleteText: deleteText
  })));
};
export default File;
//# sourceMappingURL=File.js.map